"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageIcon = void 0;
const Language_1 = __importStar(require("@opsbase/lib-i18n/Language"));
const react_1 = __importDefault(require("react"));
const react_country_flag_1 = __importDefault(require("react-country-flag"));
function LanguageIcon(props) {
    const { language = Language_1.default.ENGLISH, size = 2 } = props;
    return (react_1.default.createElement(react_country_flag_1.default, { countryCode: (0, Language_1.countryCode)(language), style: {
            fontSize: size + 'em',
            lineHeight: size / 2 + 'em',
            paddingTop: size * 2,
        } }));
}
exports.LanguageIcon = LanguageIcon;
exports.default = LanguageIcon;
